import React from 'react'
import { Modal, Button, Grid, List, Image } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom';
import Labels from '../../../common/Labels';
import MomentDate from '../../../common/MomentDate'
import ImageAvater from '../../../drive/Components/ImageAvater';
import LoadingComponent from '../../../common/LoadingComponent';
import ContentBreadCrum from '../Drive/breadcrumb/contentBreadcrum'
import { dispatch } from '@rematch/core';
import contentURL from '../../../../helpers/contentURL';
import EllipsisTooltip from '../../../common/EllipsisTooltip';
var moment = require('moment');
class ContentDetailPage extends React.Component {


    async componentWillMount() {
        if (this.props.match.params.contentId) {
            let payload = {}
            payload.contentId = this.props.match.params.contentId;
            payload.populate = true;
            await dispatch.content.getSpecificContent(payload)
        }
    }

    render() {
        let selectedContent = this.props.editContent

        const windowHeight = window.innerHeight;

        let bCat = selectedContent.baseCategory && selectedContent.baseCategory.name ? selectedContent.baseCategory.name : null;
        let cat = selectedContent.category && selectedContent.category.name ? selectedContent.category.name : null
        let sCat = selectedContent.subCategory && selectedContent.subCategory.name ? selectedContent.subCategory.name : null



        return (
            <div>
                {selectedContent ?
                    <div ref={this.parentRef} style={{ width: "100%", maxHeight: windowHeight - 200 }}>

                        <Grid className="containerBoxFullWidth">
                            <Grid.Row >
                                <ContentBreadCrum {...this.props} />
                            </Grid.Row>
                            <Grid.Row >
                                <Grid className="w_100 finalize">
                                    <Grid.Row className="blocks">
                                        <Grid.Column width={6}>
                                            <Labels
                                                name="Content Name"
                                                text={selectedContent.name} />

                                        </Grid.Column>

                                    </Grid.Row>

                                    <Grid.Row className="blocks">
                                        <Grid.Column width={5}>
                                            <Labels
                                                name="Knowledge Bank"
                                                text={<EllipsisTooltip name={bCat} />} />
                                            <Labels
                                                name="Type"
                                                text={selectedContent.type} />
                                            <Labels
                                                name="Created On"
                                                text={<MomentDate date={selectedContent.createdAt} />} />

                                        </Grid.Column>
                                        <Grid.Column width={5}>
                                            <Labels
                                                name="Category"
                                                text={<EllipsisTooltip name={cat} />} />
                                            <Labels
                                                name="Status"
                                                text={
                                                    selectedContent.status === "published" ? "Published" :
                                                        selectedContent.status === "in_development" ? "In Design" :
                                                            selectedContent.status === "rejected" ? "Rejected" :
                                                                selectedContent.status === "under_review" ? "Review request" : ''
                                                } />
                                            <Labels
                                                name="Updated On"
                                                text={<MomentDate date={selectedContent.updatedAt} />} />
                                        </Grid.Column>
                                        <Grid.Column width={6}>
                                            <Labels
                                                name="Sub Category"
                                                text={<EllipsisTooltip name={sCat} />} />
                                            <Labels
                                                name="Content Uploader"
                                                text={selectedContent.author ? selectedContent.author.firstName + " " + selectedContent.author.lastName : ''} />
                                            <Labels
                                                name="Content Author"
                                                text={selectedContent.contentAuthor ? selectedContent.contentAuthor : 'NA'} />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row className="blocks">
                                        <Grid.Column width={16}>
                                            <Labels
                                                name="Content URL"
                                                text={contentURL(selectedContent.contentpath, selectedContent.type)}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row className="blocks">
                                        <Grid.Column width={16}>
                                            <Labels
                                                name="Description"
                                                text={selectedContent.description}
                                                htmlView={true} />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Row>
                        </Grid>
                    </div>
                    : <LoadingComponent message="Loading..." active />}
            </div>

        )
    }
}
export default withRouter(ContentDetailPage)